import { initInteractiveMap } from './interactive-map/initWidget';

document.querySelectorAll<HTMLElement>('[data-kfx-interactive-map]').forEach((el) => {
  initInteractiveMap(el);
});
